import React from 'react';
import cx from 'classnames';

import { Checkbox as AntCheckbox } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox/Group';

import styles from './Checkbox.module.scss';

export interface ICheckboxGroupProps extends CheckboxGroupProps {}

export const Group: React.FC<ICheckboxGroupProps> = ({
  className,
  ...restProps
}) => (
  <AntCheckbox.Group
    className={cx(styles.Checkbox, className)}
    {...restProps}
  />
);
